<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <!-- TABLEAU COLLOQUES / SÉMINAIRES -->
            <div class="row mb-5">
              <div class="col-12">
                <h3 class="mb-2">Colloques / Séminaires</h3>
                <p class="mb-3">
                  Les Colloque/Séminaires sont organisés comme ateliers de travail pour élaborer des outils concrets d’action pour répondre à des préoccupations sociopolitiques ou ecclésiales urgentes. Ils sont suivis d’actions ou de plans d’actions.
                </p>
                <h4 class="pt-3">02 et 03 mars 2024 : Séminaire sur la femme</h4>
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead class="table-light">
                      <tr>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in colloquesSeminaires" :key="index">
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h4 class="pt-3">6-7 janvier 2023 : Colloque International sur « Education, Société et Développement »</h4>
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead class="table-light">
                      <tr>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in colloque2O23" :key="index">
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h4 class="pt-3">12 et 13 novembre 2022, Séminaire sur « l’engagement » </h4>
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead class="table-light">
                      <tr>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in seminaireEngagement" :key="index">
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h4 class="pt-3">12 mars 2022, Pré-Colloque « « Education, Société et Développement » </h4>
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead class="table-light">
                      <tr>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in precolloque2022" :key="index">
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h4 class="pt-3">1er au 3 février 2019, Colloque sur « Religions, Politique et Développement. Le paradigme de Mgr Isidore de Souza »</h4>

                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead class="table-light">
                      <tr>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in colloque2019" :key="index">
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>


            <div class="row ">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
                    <div class="blog-card style1">
                        <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
                        >
                        </div>
                        <div class="blog-info" style="min-height: 250px;">
                            <ul class="blog-metainfo  list-style">
                                <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                            </ul>
                            <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                            <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                                <i class="flaticon-right-arrow"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'DiesAcademicus',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const colloquesSeminaires = ref([
  // Séminaire sur la femme – mars 2024
  {
    theme: "Les figures modèles de femmes engagées dans nos cultures et dans la communauté contemporaine",
    communicateur: "Docteur Epiphanie HOUNYE",
  },
  {
    theme: "Figures de femmes dans nos traditions culturelles. Pistes pour valoriser la place des femmes dans l’Eglise",
    communicateur: "Professeure Maryse QUASHIE",
  },
  {
    theme: "Femmes et genre : quelles approches éthiques pertinentes aujourd’hui face aux mutations sociales",
    communicateur: "Maître Marie Odile ATTANASSO",
  },
  {
    theme: "Théologie de la femme dans la Bible : le cas de Déborah, Judith et Esther",
    communicateur: "Père Fiacre GAMBADATOUN",
  },
  {
    theme: "Spécificité et complémentarité de l’homme et de la femme face aux défis LGBT : approche anthropologique et psychologique",
    communicateur: "Père Magloire OKRY",
  },
  {
    theme: "Le rôle des femmes dans l’éducation face à l’internalisation des modèles étrangers par l’invasion des productions médiatiques",
    communicateur: "Maître Natacha BALLEY",
  },
])

const colloque2O23 = ref([
  
  // Colloque international – janvier 2023
  {
    theme: "L’Éducation, une épiphanie",
    communicateur: "Père Rodrigue GBÉDJINOU",
  },
  {
    theme: "Déficit humain en Afrique et formation à l’humanité",
    communicateur: "M. Cyriaque AHODEKON",
  },
  {
    theme: "La finalité de l’école : Étude de L’Aventure ambiguë de Cheikh HamidouKANE à partir de l’analyse des propos de la Grande Royale ",
    communicateur: "Père Rodrigue GBÉDJINOU",
  },
  {
    theme: "Le Shema comme paradigme (Dt 6, 4-9). Bible, éducation et quête du développement dans le Ghana Contemporain",
    communicateur: "Père Michael MENSAH",
  },
  {
    theme: "Repenser aujourd’hui la catéchèse et l’aumônerie comme cadre d’éducation religieuse et sociale",
    communicateur: "Père Jean-Baptiste MASSON",
  },
  {
    theme: "L’esprit de l’éducation aujourd’hui dans un monde globalisé",
    communicateur: "Sœur Marguerite LENA",
  },
  {
    theme: "La vie chrétienne comme style de vie à partir d’une médiation sur le Ecce Homo : interpellations théologicopastorales",
    communicateur: "Père Édouard ADÈ",
  },
  {
    theme: "Travailler ensemble : liberté et responsabilité",
    communicateur: "Sœur Tiziana BORSANI",
  },

  // Ateliers
  { theme: "Enfance et Jeunesse (Atelier)", communicateur: "Mme Joséphine KANAKIN" },
  { theme: "Femmes : formation de l’homme (Atelier)", communicateur: "Mme Claire HOUNGAN AYÉMONNA" },
  { theme: "Familles (Atelier)", communicateur: "M. Arsène DANSI BOCO" },
  { theme: "Formation civique (Atelier)", communicateur: "M. Raphaël YÉBOU" },
  { theme: "La culture (Atelier)", communicateur: "Père Bienvenu AKODOH" },
  { theme: "Mouvements charismatiques (Atelier)", communicateur: "M. Victor TOGBÉ" },
  { theme: "La liturgie comme formation à l’intériorité (Atelier)", communicateur: "Père Romaric AMOUZOUVI" },
  { theme: "La Parole de Dieu comme lieu d’éducation (Atelier)", communicateur: "Pasteur Daniel BANKOLÉ" },
  { theme: "La catéchèse (Atelier)", communicateur: "Sœur Antoinette LUGUDOR" },
  { theme: "Personnalités politiques (Atelier)", communicateur: "M. William KODJOHKPAKPASSOU" },
  { theme: "Table ronde", 
  communicateur: "M. Cyriaque AHODÉKON ; Père Jean-Baptiste MASSON ; Aimé AKALA; Lionel WHANNOU; Jules AGUESSY; Abbé Canisius AKLEM. Serge AYAKA" },
  { theme: "Rapport général ", communicateur: "Père Narcisse BAHKPÊVI" },
  { theme: "L’éducation, une Pâques et une Pentecôte", communicateur: "Père Rodrigue GBÉDJINOU" },

])

const seminaireEngagement = ref([
   {
    theme: "Se former pour l’engagement ",
    communicateur: "Père Rodrigue GBÉDJINOU",
  },
  {
    theme: "La formation des jeunes leaders chrétiens ",
    communicateur: "M. Jules ADANCHÉDÉ HOUNKPONOU",
  },
  {
    theme: "Les jeunes chrétiens et les clubs services",
    communicateur: "M. Achille Sègbégnon SONEHEKPON Père Rodrigue GBÉDJINOU",
  },

])

const precolloque2022 = ref([
  {
    theme: "Education-Société et Développement.Quel homme pour quelle société ? ",
    communicateur: "M. Jean-Claude HOUNMÈNOU",
  },
  {
    theme: "Jeunes et Enfants (Atelier)",
    communicateur: "Père Roland TÉCHOU (animateur)",
  },
  {
    theme: "Familles (Atelier) ",
    communicateur: "M. Raphaël YÉBOU (animateur)",
  },
  {
    theme: "Renforcement des capacités des femmes (Atelier)",
    communicateur: "Mme Joséphine KANAKIN (animatrice)",
  },
  {
    theme: "Formation civique et politique (Atelier)",
    communicateur: "Mme Blanche SONON (animatrice)",
  },
  {
    theme: "Communautés charismatiques (Atelier)",
    communicateur: "Mme Lucrèce NAHUM TÉVOÉDJRÈ (animatrice)",
  },
  {
    theme: "Agents pastoraux (Atelier) ",
    communicateur: "Sœur Béatrice AGBO (animatrice)",
  },
   {
    theme: "Écoles catholiques (Atelier)  ",
    communicateur: "M. KOUDOADINOU Roger (animateur)"
  },
   {
    theme: "Écoles publiques (Atelier) ",
    communicateur: "M. NASSARA Augustin (animateur)",
  },

])

const colloque2019 = ref([
  {
    theme: "Démocratie, État de droit et élections en Afrique : acquis, fragilités et perspectives",
    communicateur: "M. Ibrahim SALAMI",
  },
  {
    theme: "Monseigneur Isidore de Souza : des discours fondateurs à la pensée politique",
    communicateur: "Mme Célestine ZANOU",
  },
  {
    theme: "Axes théologico-pastoraux de Mgr Isidore de Souza: pasteur qui vit avec.",
    communicateur: "Père Justin AGOSSOU-KPÈVI",
  },
  {
    theme: "La figure du prophète Jérémie dans le règlement de crise dans le Royaume de Juda. Éclairage biblique sur la mission politique de Monseigneur Isidore de Souza.",
    communicateur: "M. Timothée GANDONOU",
  },
  {
    theme: "L’Église catholique en Afrique aujourd’hui : frein ou stimulant à l’enracinement de la démocratie pour le continent ?",
    communicateur: "Mme Blandine CHELINI-PONT",
  },
  {
    theme: "Répondre de l’histoire avec Mgr Isidore de Souza : la nécessité d’une science des institutions.",
    communicateur: "Père Brice OUINSOU",
  },
  {
    theme: "Démocratie et éthique politique en Afrique. Eloge de la Vérité, de la conscience et de la mémoire.",
    communicateur: "Père Rodrigue GBÉDJINOU",
  },
  {
    theme: "La culture de la mémoire à partir de la figure de Mgr Isidore de Souza.",
    communicateur: "Père Aimé HOUNZANDJI",
  },
  {
    theme: "Mgr Isidore de Souza et ses œuvres : mystique et points de repères.",
    communicateur: "Mme Jeanne MÉGAN",
  },
  {
    theme: "Mgr Isidore de Souza, un témoin crédible du Christ pour le Bénin et pour l’Afrique.",
    communicateur: "M. Bruno ADJAHOUNZO et Pasteur AKPO",
  },
  {
    theme: "L’Église peut-elle encore être médiatrice aujourd’hui ? Le cas de Mgr Isidore de Souza.",
    communicateur: "Père Justin AGOSSOU-KPÈVI",
  },

  {
    theme: "La dimension politique de la religion : quelle forme de laïcité ?",
    communicateur: "M. Expédit OLOGOU",
  },
  {
    theme: "Les pesanteurs socioculturelles africaines : ce qu’en disent les religions.",
    communicateur: "Les pesanteurs socioculturelles africaines : ce qu’en disent les religions.	M. Koffi AZA",
  },
  {
    theme: "Les pesanteurs socioculturelles africaines : ce qu’en disent les religions.",
    communicateur: "M. Sègbédé ALIGBONON",
  },
  
  {
    theme: "Pathologies religieuses et culturelles en Afrique",
    communicateur: "Père Ambroise KINHOUN",
  },

])

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/34?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        colloque2O23,
        seminaireEngagement,
        precolloque2022,
        colloque2019,
        colloquesSeminaires,
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
</style>